import {
    type BasketActionsType,
    ADD_EXTRA,
    ADD_FINANCE_PACK,
    ADD_FINANCE_PACK_EXTRAS,
    ADD_FINANCE_PACK_SERVICEPRODUCTS,
    ADD_PACK,
    ADD_PACK_EXTRA,
    ADD_SERVICE_PRODUCT,
    ADD_USER_SELECTED_PROMOTION,
    CALCULATE_PRICE,
    INIT_BASKET,
    LOAD_USER_SELECTED,
    PUSH_USER_SELECTED,
    REMOVE_EXTRA,
    REMOVE_FINANCE_PACK,
    REMOVE_FINANCE_PACK_EXTRAS,
    REMOVE_FINANCE_PACK_SERVICEPRODUCTS,
    REMOVE_PACK,
    REMOVE_PACK_EXTRA,
    REMOVE_SERVICE_PRODUCT,
    REMOVE_USER_SELECTED_PROMOTION,
    REMOVE_WINTER_WHEEL,
    RESET_BASKET,
    SET_COLOUR,
    SET_CONFIGURATION,
    SET_EXTRA_OPTION,
    SET_PRIMARY_ACCENT_COLOUR,
    SET_SECONDARY_ACCENT_COLOUR,
    SET_UPHOLSTERY,
    SET_WHEEL,
    SET_WINTER_WHEEL,
    UPDATE_EXTRA_SET_ITEMS,
} from "../actions/BasketActions";

import { find } from "../../../../../common-deprecated/utils";
import { getDefaultPriceObject } from "../../../../../common-deprecated/constants";
import type { BasketType } from "../../../../shared-logic/types/BasketType";

// TODO replace this with the defaultBasketObject in constants.
export const initialState: BasketType = {
    initialized: false,
    colour: {
        id: "",
        code: "",
        internalCode: "",
        image: "",
        name: "",
        type: "",
        price: { ...getDefaultPriceObject() },
        standard: false,
        rgb: "",
        upholsteries: [],
        upholsteriesCarConfigurator: [],
        upholsteryOnlineAvailability: [],
        description: null,
    },
    primaryAccentColour: null,
    secondaryAccentColour: null,
    upholstery: {
        id: "",
        objectType: "upholstery",
        shortId: "",
        internalCode: "",
        name: "",
        price: { ...getDefaultPriceObject() },
        default: false,
        standard: false,
        image: "",
        description: null,
        index: 0,
        sortIndex: 0,
        availableForColours: [],
    },
    wheel: {
        id: "",
        shortId: "",
        code: "",
        name: "",
        objectType: "wheel",
        price: { ...getDefaultPriceObject() },
        standard: false,
        isWheel: true,
        visualisation: [],
        setItems: [],
        image: "",
        description: null,
        footNote: null,
        index: 0,
        type: "option",
        included: [],
        excluded: [],
        includePacks: [],
        excludePacks: [],
        availability: {
            colours: [],
            upholsteries: [],
        },
        sortIndex: 0,
    },
    extras: [],
    packs: [],
    financePacks: [],
    financePackExtras: [],
    financePackServiceProducts: [],
    serviceProducts: [],
    packExtras: [],
    total: {
        ...getDefaultPriceObject(),
        isExternalPrice: false,
        discountTax: 0,
        discountWithoutTax: 0,
    },
    userSelected: [],
    userSelectedPromotions: [],
    winterWheel: null,
};

const BasketReducer = (state = initialState, action: BasketActionsType): BasketType => {
    switch (action.type) {
        case ADD_USER_SELECTED_PROMOTION:
            const userSelectedPromotions = [...state.userSelectedPromotions];
            if (!userSelectedPromotions.find((promo) => promo.id === action.promotion.id)) {
                userSelectedPromotions.push(action.promotion);
            }
            return { ...state, userSelectedPromotions };

        case REMOVE_USER_SELECTED_PROMOTION:
            const userSelectedPromotionsRemove = [...state.userSelectedPromotions];
            return {
                ...state,
                userSelectedPromotions: userSelectedPromotionsRemove.filter(
                    (promo) => promo.id !== action.promotion.id,
                ),
            };

        case RESET_BASKET:
            return { ...state, ...action.basket };

        case INIT_BASKET:
            return { ...state, ...action.basket, initialized: true };

        case SET_WHEEL:
            return {
                ...state,
                wheel: action.wheel,
            };
        case SET_WINTER_WHEEL:
            return {
                ...state,
                winterWheel: action.winterWheel,
            };

        case REMOVE_WINTER_WHEEL:
            return {
                ...state,
                winterWheel: null,
            };

        case SET_COLOUR:
            return { ...state, colour: action.colour };

        case SET_PRIMARY_ACCENT_COLOUR:
            return { ...state, primaryAccentColour: action.colour };

        case SET_SECONDARY_ACCENT_COLOUR:
            return { ...state, secondaryAccentColour: action.colour };

        case SET_UPHOLSTERY:
            return { ...state, upholstery: action.upholstery };

        case ADD_FINANCE_PACK:
            return {
                ...state,
                financePacks: !find(action.financePack.id, state.financePacks)
                    ? [...state.financePacks, action.financePack]
                    : state.financePacks,
            };

        case ADD_FINANCE_PACK_EXTRAS:
            return {
                ...state,
                financePacks: !find(action.financePack.id, state.financePacks)
                    ? [...state.financePacks, action.financePack]
                    : state.financePacks,
                financePackExtras: !find(action.extra.id, state.financePackExtras)
                    ? [...state.financePackExtras, action.extra]
                    : state.financePackExtras,
            };

        case REMOVE_FINANCE_PACK: {
            return {
                ...state,
                financePacks: state.financePacks.filter((pack) => pack.id !== action.financePack.id),
            };
        }

        case REMOVE_FINANCE_PACK_EXTRAS: {
            return {
                ...state,
                financePackExtras: state.financePackExtras.filter((packExtra) => packExtra.id !== action.extra.id),
            };
        }

        case ADD_PACK: {
            action.pack.userSelected = action.userSelected;
            return {
                ...state,
                // Add the pack if it is not present yet
                packs: !find(action.pack.id, state.packs) ? [...state.packs, action.pack] : state.packs,
            };
        }

        case ADD_FINANCE_PACK_SERVICEPRODUCTS:
            return {
                ...state,
                financePacks: !find(action.financePack.id, state.financePacks)
                    ? [...state.financePacks, action.financePack]
                    : state.financePacks,
                financePackServiceProducts: !find(action.serviceProduct.id, state.financePackServiceProducts)
                    ? [...state.financePackServiceProducts, action.serviceProduct]
                    : state.financePackServiceProducts,
            };

        case REMOVE_FINANCE_PACK_SERVICEPRODUCTS: {
            return {
                ...state,
                financePackServiceProducts: state.financePackServiceProducts.filter(
                    (packServiceProduct) => packServiceProduct.id !== action.serviceProduct.id,
                ),
            };
        }

        case ADD_PACK_EXTRA: {
            const packExtras = action.combinedSelectedExtras
                ? action.combinedSelectedExtras.reduce(
                      (accumulator, extra) => {
                          if (!find(extra.id, accumulator)) accumulator.push(extra);
                          return accumulator;
                      },
                      [...state.packExtras],
                  )
                : state.packExtras;

            return {
                ...state,
                // Add the pack if it is not present yet
                packs: !find(action.pack.id, state.packs) ? [...state.packs, action.pack] : state.packs,
                packExtras,
            };
        }

        case REMOVE_PACK: {
            return {
                ...state,
                packs: state.packs.filter((pack) => pack.id !== action.pack.id),
            };
        }

        case REMOVE_PACK_EXTRA: {
            return {
                ...state,
                packExtras: state.packExtras.filter((packExtra) => packExtra.id !== action.extra.id),
            };
        }

        case ADD_EXTRA: {
            return {
                ...state,
                extras: [
                    ...state.extras,
                    {
                        ...action.extra,
                        userSelected: !action.automatic,
                        selectedOptionId: action.optionId || "",
                        setItems: action.setItems || [],
                    },
                ],
            };
        }

        case SET_EXTRA_OPTION: {
            const extraIndex = state.extras.findIndex((extra) => extra.id === action.extra.id);
            const extra = { ...state.extras[extraIndex], selectedOptionId: action.optionId };
            const newExtras = [...state.extras];
            newExtras[extraIndex] = extra;

            return { ...state, extras: newExtras };
        }

        case UPDATE_EXTRA_SET_ITEMS: {
            const extraIndex = state.extras.findIndex((extra) => extra.id === action.extra.id);
            const extras = [...state.extras];
            extras.splice(extraIndex, 1, { ...action.extra, setItems: action.setItems });
            return {
                ...state,
                extras,
            };
        }

        case REMOVE_EXTRA:
            return { ...state, extras: state.extras.filter((equipment) => equipment.id !== action.extra.id) };

        case CALCULATE_PRICE: {
            return { ...state, total: action.total as BasketType["total"] };
        }

        case PUSH_USER_SELECTED: {
            const { selectedType, id } = action;
            const userSelected = [{ selectedType, id }, ...state.userSelected] as BasketType["userSelected"];
            return { ...state, userSelected };
        }

        case LOAD_USER_SELECTED:
            return { ...state, userSelected: action.userSelected };

        case SET_CONFIGURATION:
            return { ...state, ...action.configuration };

        case ADD_SERVICE_PRODUCT:
            return {
                ...state,
                serviceProducts: !find(action.serviceProduct.id, state.serviceProducts)
                    ? [...state.serviceProducts, action.serviceProduct]
                    : state.serviceProducts,
            };

        case REMOVE_SERVICE_PRODUCT:
            return {
                ...state,
                serviceProducts: state.serviceProducts.filter(
                    (serviceProduct) => serviceProduct.id !== action.serviceProduct.id,
                ),
            };

        default: {
            return state;
        }
    }
};

export default BasketReducer;
